export default {
  请选择所属行业: '请选择所属行业',
  所属行业不能为空: '所属行业不能为空',
  拖动照片可以调整顺序: '拖动照片可以调整顺序',
  该企业主页不存在: '该企业主页不存在',
  已停止访问该网页: '已停止访问该网页',
  原因如下: '原因如下',
  上市公司: '上市公司',
  世界500强: '世界500强',
  营业执照: '营业执照',
  公司官网: '公司官网',
  交换云展: '交换云展',
  立即分享: '立即分享',
  在线洽谈: '在线洽谈',
  云上企业: '云上企业',
  企业视频: '企业视频',
  云视频: '云视频',
  企业简介: '企业简介',
  查看全文: '查看全文',
  收起全文: '收起全文',
  合作伙伴: '合作伙伴',
  企业相册: '企业相册',
  企业员工: '企业员工',
  企业荣誉: '企业荣誉',
  投资机构: '投资机构',
  对外投资: '对外投资',
  联系我们: '联系我们',
  提醒更新: '提醒更新',
  暂未上传云企业: '暂未上传云企业',
  暂未上传云产品: '暂未上传云产品',
  暂无云直播: '暂无云直播',
  暂无参展: '暂无参展',
  暂无开展: '暂无开展',
  暂无云招标信息: '暂无云招标信息',
  暂无云动态: '暂无云动态',
  暂无云头条: '暂无云头条',
  暂无上传云模型: '暂无上传云模型',
  暂无云海报: '暂无云海报',
  暂无云会议: '暂无云会议',
  暂无云招聘: '暂无云招聘',
  暂未上传云伙伴: '暂未上传云伙伴',
  暂未上传云相册: '暂未上传云相册',
  暂未上传云同事信息: '暂未上传云同事信息',
  暂未上传云荣誉: '暂未上传云荣誉',
  暂无员工名片: '暂无员工云展',
  暂未上传企业视频: '暂未上传企业视频',
  注册资本: '注册资本',
  成立日期: '成立日期',
  所属行业: '所属行业',
  企业地址: '企业地址',
  发布的展览: '发布的展览',
  发布的会议: '发布的会议',
  直播: '直播',
  招标: '招标',
  产业头条: '产业头条',
  动态: '动态',
  展品: '展品',
  参展的展览: '参展的展览',
  展厅模型: '展厅模型',
  海报制作: '海报制作',
  确认删除吗: '确认删除吗？',
  删除: '删除',
  人浏览过: '人浏览过',
  浏览者头像: '浏览者头像',
  确认: '确认',
  取消: '取消',
  删除提示: '删除提示',
  发布: '发布',
  投资比例: '投资比例',
  认缴金额: '认缴金额',
  万元: '万元',
  云上: '云上',
  交换: '交换',
  企业云展系统: '企业云展系统',
  完善企业云展系统: '完善企业云展系统',
  获客营销神器: '获客营销神器',
  足不出户带客户同逛企业: '足不出户带客户同逛企业',
  与全球客户实时洽谈互动: '与全球客户实时洽谈互动',
  智能推送精准客户: '智能推送精准客户',
  实时掌握访问数据: '实时掌握访问数据',
  去完善: '去完善',
  编辑: '编辑',
  分享: '分享',
  企业: '企业',
  请更新名片: '请更新云展!',
  立即更新: '立即更新',
  修改名片: '修改云展',
  复制链接成功: '复制链接成功',
  复制失败提示: '复制失败,建议更换浏览器或手动复制链接：',
  分享失败提示: '分享失败,请稍候再试',
  微信小程序码生成错误: '微信小程序码生成错误',
  企业信息: '企业信息',
  暂无企业地址: '暂无企业地址',
  暂无联系人信息: '暂无联系人信息',
  二维码: '二维码',
  微信公众号: '微信公众号',
  微信小程序: '微信小程序',
  微信小程序二维码: '微信小程序二维码',
  暂无二维码信息: '暂无二维码信息',
  微博: '微博',

  '+ 关注': '+ 关注',
  个人动态: '个人动态',

  云工商: '云工商',
  云官网: '云官网',
  我的名片: '我的名片',
  // 交换云展: '交换云展',
  编辑云展信息: '编辑云展信息',
  云企业: '云企业',
  云展厅: '云展厅',
  云简介: '云简介',
  云伙伴: '云伙伴',
  云相册: '云相册',
  云同事: '云同事',
  云荣誉: '云荣誉',
  云投资: '云投资',
  云战略: '云战略',
  云直播: '云直播',
  云招标: '云招标',
  云头条: '云头条',
  云动态: '云动态',
  云产品: '云产品',
  云展览: '云展览',
  云模型: '云模型',
  云海报: '云海报',
  提升权益: '提升权益',
  外呼呼叫: '外呼呼叫',
  去外呼: '去外呼',
  充值点数: '充值点数',
  冻结中点数: '冻结中点数',
  到期时间: '到期时间',
  话术管理: '话术管理',
  外呼任务管理: '外呼任务管理',
  呼叫记录: '呼叫记录',
  企业客户库: '企业客户库',
}
